import classnames from 'classnames';
import React, { ReactElement, useEffect, useRef } from 'react';
import { ZCDDataVisualizationColor } from '@zencity/common-ui';
import { ConcernItem } from 'screens/WidgetGenerator/utils/answerClassificationBreakdown';
import { TopConcernsChartItemTrend } from 'screens/WidgetGenerator/reportGeneratorComponents/components/ClassificationTopConcernsHOC/TopConcernsChartItemTrend';
import styles from './ClassificationTopConcernsHOC.module.scss';

const CANVAS_WIDTH = 80;
const CANVAS_HEIGHT = 10;

interface Props {
  concernItem: ConcernItem;
  highestTotal: number;
  color: keyof typeof ZCDDataVisualizationColor;
  displayTrend: boolean;
}

export const TopConcernsChartItem = (props: Props): ReactElement => {
  const { concernItem, highestTotal, color, displayTrend } = props;
  const canvasRef = useRef<HTMLCanvasElement | null>(null);

  const barPercentage = highestTotal > 0 ? concernItem.total / highestTotal : 1;

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) {
      return;
    }

    const context = canvas.getContext('2d');
    if (!context) {
      return;
    }

    context.clearRect(0, 0, CANVAS_WIDTH, CANVAS_HEIGHT);
    context.fillStyle = ZCDDataVisualizationColor[color];
    context.fillRect(0, 0, CANVAS_WIDTH * barPercentage, CANVAS_HEIGHT);
  }, [barPercentage, color, concernItem.percentage]);

  return (
    <div
      className={classnames(styles.chartItem, {
        [styles.displayTrend]: displayTrend,
      })}
    >
      <div className={styles.canvasWrapper}>
        <canvas ref={canvasRef} width={CANVAS_WIDTH} height={CANVAS_HEIGHT} />
      </div>
      <div className={styles.chartItemValue}>{Math.round(concernItem.percentage)}%</div>
      <TopConcernsChartItemTrend concernItem={concernItem} displayTrend={displayTrend} />
      <div className={styles.chartItemLabel}>{concernItem.label}</div>
    </div>
  );
};
